/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import { StationService } from "../../common/svg/AllSvg";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { url } from "../../../shared/utils/url";
import useAxios from "../../../shared/hooks/use-axios";

const Banner = ({ line }: any) => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [stCount, setStCount] = useState<any>(null)

    const getStatus = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.st_status_statistics}`);

            if (res && res?.status === 200) {
                setStCount(res?.data)
            }
        } catch (error) {
            console.error("error while feching line list", error);
        }
    };

    useEffect(() => {
        !!lang && getStatus();
    }, [lang])

    return (
        <div className="w-full h-full container flex absolute left-0 right-0 bottom-0 pb-[40px] xlx:pb-[55px] items-start xsm:items-end justify-end xsm:justify-between gap-y-[20px] gap-x-[15px] xsm:flex-row flex-col md:!px-[30px] xlx:!px-[50px]">
            {!!line ? <div className="flex flex-col gap-[8px] xlx:gap-[10px]">
                <h2 className="text-primary font-bold uppercase">{line?.name}</h2>
                <h6 className="xlx:!leading-[19px] h-[25px] flex items-center justify-center pl-[5px] pr-[9px] bg-[#ECECEC] text-blackDull font-bold rounded-[50px] w-fit gap-[2px]">
                    <StationService className={`${(line?.status === "Normal Service" || line?.status === "सामान्य सेवाएँ" || line?.status === "सामान्य सेवा") ? "fill-success" : (line?.status === "Delay in Service" || line?.status === "सेवा में देरी" || line?.status === "सेवेत विलंब") ? "fill-[#D4741B]" : (line?.status === "No Service" || line?.status === "सेवा निषेद" || line?.status === "सेवा नाही") ? "fill-secDarkRed" : "fill-[#B2AE45]"}`} />
                    {line?.status}
                </h6>
            </div> : <div></div>}

            <div className="flex flex-col gap-[5px]">
                <p className="text-black dark:text-white font-semibold">{t("passenger.home.know_st.st.st_status")}</p>
                <div style={{ background: "linear-gradient(93deg, #E7FDF9 6.73%, #F2FFFC 100.26%)" }} className="shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] rounded-[12px] px-[18px] xlx:px-[23px] py-[15px] xlx:py-[19px] flex gap-[18px]">
                    <div className="flex flex-col gap-[2px] xlx:gap-[3px]">
                        <h4 className="text-blackDark font-bold !leading-[19px]">{!!stCount?.station_open_count ? stCount?.station_open_count : 0}</h4>
                        <p className="text-blackDull font-semibold">{t("passenger.line.status.normal")}</p>
                    </div>

                    <div className="flex flex-col gap-[2px] xlx:gap-[3px]">
                        <h4 className="text-blackDark font-bold !leading-[19px]">{!!stCount?.station_closed_count ? stCount?.station_closed_count : 0}</h4>
                        <p className="text-blackDull font-semibold">{t("passenger.line.status.no_service")}</p>
                    </div>

                    <div className="flex flex-col gap-[2px] xlx:gap-[3px]">
                        <h4 className="text-blackDark font-bold !leading-[19px]">{!!stCount?.station_partial_open_count ? stCount?.station_partial_open_count : 0}</h4>
                        <p className="text-blackDull font-semibold">{t("passenger.line.status.maintenance")}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;